// this was copied from libs/data/search/src/lib/constants/filters-constants.ts to get around a circular dependency issue
// despite physically being in data-search, it's exported from libs/search/feature-search-filters/src/index.ts
// TODO: fix this mess, and remove the need for duplicated constants by moving it somewhere that doesn't cause circular dependencies and allows it to be re-used!

export const searchFilterKeys = [
  'bodyType',
  'colour',
  'seats',
  'doors',
  'fromEngineSize',
  'toEngineSize',
  'fuelType',
  'make',
  'model',
  'trim',
  'mileage',
  'fromPrice',
  'toPrice',
  'rangeInMiles',
  'gearbox',
  'fromYear',
  'toYear',
  'driveType',
  'store',
  'tags',
  'features',
  'financeType',
] as const

export const nonFilterParamKeys = [
  'sortingCriteria',
  'pageSize',
  'pageNumber',
  'useMonthly',
] as const

export const searchParamKeys = [
  ...searchFilterKeys,
  ...nonFilterParamKeys,
] as const
